import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DropdownModule} from 'ng2-bootstrap/dropdown';

import {LanguageDropdownComponent} from './language-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule.forRoot(),
  ],
  declarations: [
    LanguageDropdownComponent,
  ],
  providers: [],
  exports: [
    LanguageDropdownComponent,
  ],
})
export class LanguageDropdownModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/language-dropdown/language-dropdown.module.ts